import { listDept, getUserAllcompany } from "@/api/system/dept";
import { login, logout, getInfo } from "@/api/login";
import { getToken, setToken, removeToken } from "@/utils/auth";
import { appToken, accessToken } from "@/api/ierp/token";

const user = {
  state: {
    isLoggedIn: false, // 控制登录状态
    iERPToken: null, // 存储 token
  },

  mutations: {
    SET_USER_ALLCOMPANY(state, companyArr) {
      state.mainAllCompany = companyArr;
    },
    SET_IERP_TOKEN(state, token) {
      state.iERPToken = token;
      state.isLoggedIn = true; // 登录成功后设置为 true
    },
    LOGOUT(state) {
      state.iERPToken = null;
      state.isLoggedIn = false; // 退出登录时设置为 false
    },
  },

  actions: {
    GetIERP({ commit },userInfo) {
      return new Promise(async (resolve, reject) => {
        const env = process.env.VUE_APP_ENV;
        const username = userInfo.username.trim();
        let data = undefined;
        let accdata = undefined;
        if (env == "staging") {
          data = {
            appId: "dk_map",
            appSecret: "DKsp@2024!QAZxsw2",
            tenantid: "dk-test",
            accountId: "2128591396511156224",
          };
          accdata = {
            user: username,
            usertype: "Mobile",
            apptoken: "",
            tenantid: "dk-test",
            accountId: "2128591396511156224",
            language: "zh_CN",
          };
        } else if (env == "dev") {
          data = {
            appId: "dk_map",
            appSecret: "DKsp@2024!QAZxsw2",
            tenantid: "dk-uat",
            accountId: "2108719383776857088",
          };
          accdata = {
            user: username,
            usertype: "Mobile",
            apptoken: "",
            tenantid: "dk-uat",
            accountId: "2108719383776857088",
            language: "zh_CN",
          };
        } else if (env == "production") {
          data = {
            appId: "dk_map",
            appSecret: "DKsp@2024!QAZxsw2",
            tenantid: "dk-prod",
            accountId: "1911576402684019712",
          };
          accdata = {
            user: username,
            usertype: "Mobile",
            apptoken: "",
            tenantid: "dk-prod",
            accountId: "1911576402684019712",
            language: "zh_CN",
          };
        }

        try {
                    // 置空 iERPToken
                    commit("SET_IERP_TOKEN", null);
                    commit("isLoggedIn", false);
          // 获取 app_token
          const appTokenResponse = await appToken(data);
          if (!appTokenResponse.status) {
            throw new Error("Failed to retrieve app token");
          } else {
            accdata.apptoken = appTokenResponse.data.app_token;
          }

          // 获取 access_token
          const accessTokenResponse = await accessToken(accdata);
          if (!accessTokenResponse.status) {
            throw new Error(accessTokenResponse.message);
          }
          setToken(accessTokenResponse.data.access_token);

          // 如果获取到 access_token，提交到 Vuex
          commit("SET_IERP_TOKEN", accessTokenResponse.data.access_token);

          // 成功时 resolve
          resolve(accessTokenResponse.data.access_token);
        } catch (error) {
          // 发生错误时 reject
          console.error("Error in GetIERP:", error);
          reject(error);
        }
      });
    },

    // 退出系统
    LogOut({ commit, state }) {
      return new Promise((resolve, reject) => {
        logout(state.token)
          .then(() => {
            commit("SET_TOKEN", "");
            commit("SET_ROLES", []);
            commit("SET_PERMISSIONS", []);
            removeToken();
            resolve();
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
  },
};

export default user;
